import {ReactElement} from 'react'
import {UnlockYourTradingPotentialBanner} from './components/UnlockYourTradingPotentialBanner'
import {CompanyEnumIndices} from '@bdswiss/common-enums'
import PremierLeagueBanner from './components/PremierLeagueBanner'
import {BannersCarouselProps} from './types'

type GetBannerSlidesInput = BannersCarouselProps

export function getBannerSlides({company, isClientEligible}: GetBannerSlidesInput): ReactElement[] {
  if (company === CompanyEnumIndices.tauroMarkets) {
    return [
      <PremierLeagueBanner isClientEligible={isClientEligible} />,
      <UnlockYourTradingPotentialBanner />,
    ]
  }

  return [<UnlockYourTradingPotentialBanner />]
}
